import { StatusLabel } from "@shared/StatusLabel";

import { getSubscriptionStatusLabel, getSubscriptionStatusTone } from "./subscriptionStatus";

export const SubscriptionStatusLabel = ({ status }: { status: string }) => (
    <StatusLabel tone={getSubscriptionStatusTone(status)}>{getSubscriptionStatusLabel(status)}</StatusLabel>
);
